import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobWorkSummaryId'}/restoreOriginal`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobWorkSummaryId/restoreOriginal`;

export const URL = (jobWorkSummaryId: number): RouteDefinition => `${baseRoute}/${jobWorkSummaryId}/restoreOriginal`;
